// Constants
import {
  XPRESS_ID_EVENT_ERROR,
  XPRESS_ID_EVENT_PROCESS_CANCELED,
  XPRESS_ID_EVENT_PROCESS_EVENTS,
  XPRESS_ID_EVENT_QR_ERROR,
  XPRESS_ID_EVENT_QR_FINISHED,
  XPRESS_ID_ORIGIN,
} from './constants/upload-id-verification.handlers.utils.constants';
// Enumerations
import { UploadIdOcrStatesEnumeration } from '../../enumerations/upload-id-ocr-states.enumeration';
// Types
import { UploadIdVerificationReceiveDataBuilderHandlersType } from '../types/upload-id-verification.handlers.type';
import { ShouldShowErrorFromEventType } from './types/upload-id-verification.handlers.utils.type';

const customerInformationNeedApproval = (
  message: UploadIdVerificationReceiveDataBuilderHandlersType['message']
): boolean =>
  message?.detail?.payload?.status === UploadIdOcrStatesEnumeration.NEEDS_CUSTOMER_CONFIRM;

const OCRDataIsSuccessfullyVerified = (
  message: UploadIdVerificationReceiveDataBuilderHandlersType['message']
): boolean => message?.detail?.payload?.status === UploadIdOcrStatesEnumeration.ACCEPTED;

const eventIsNotFromVeridas = (origin: string): boolean => !origin.includes(XPRESS_ID_ORIGIN);

const isErrorType = (type: string): boolean => type === XPRESS_ID_EVENT_ERROR;

const isProcessCancelledCode = (code: string): boolean => code === XPRESS_ID_EVENT_PROCESS_CANCELED;

const isProcessEventsCode = (code: string): boolean => code === XPRESS_ID_EVENT_PROCESS_EVENTS;

const isQRProcessError = (code?: string): boolean => code === XPRESS_ID_EVENT_QR_ERROR;

const shouldShowErrorFromEvent = ({
  code,
  type,
  infoEvent,
}: ShouldShowErrorFromEventType): boolean =>
  isErrorType(type) || isProcessCancelledCode(code) || isQRProcessError(infoEvent?.code);

const isQrProcessFinished = (code: string): boolean => code === XPRESS_ID_EVENT_QR_FINISHED;

export {
  customerInformationNeedApproval,
  eventIsNotFromVeridas,
  isErrorType,
  isProcessCancelledCode,
  isProcessEventsCode,
  isQRProcessError,
  isQrProcessFinished,
  OCRDataIsSuccessfullyVerified,
  shouldShowErrorFromEvent,
};
